// frontend/src/store/useUIStore.js
import { create } from 'zustand';

export const useUIStore = create((set) => ({
  sidebarOpen:   false,
  openSidebar:   () => set({ sidebarOpen: true }),
  closeSidebar:  () => set({ sidebarOpen: false }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
}));